declare global {
  interface Window {
    process?: {
      env?: Record<string, string>;
    };
  }
}

if (typeof window.process === 'undefined') {
  window.process = { env: { NODE_ENV: 'development' } };
}

export {};
